import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/SEO/SEO';
import PageHeader from '../../components/PageHeader/PageHeader';
import styles from './Legals.module.css';

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === 'en';

  return (
    <div className={styles.legalsPage}>
      <SEO
        title={t('seo.privacyTitle')}
        description={t('legals.privacyDesc')}
        canonicalPath={`/${isEn ? 'privacy-policy' : 'politica-privacidad'}`}
      />

      <PageHeader
        title={t('legals.privacyTitle')}
        description={t('legals.privacyDesc')}
      />

      <section className="container">
        <div className={styles.legalsContent}>
          <div>
            <p>
              En CINBIOSIS (en adelante "la Empresa"), estamos comprometidos con la protección de la privacidad y los datos personales de nuestros usuarios, clientes, proveedores y colaboradores. Esta Política de Privacidad describe cómo recopilamos, utilizamos, almacenamos y protegemos la información personal.
            </p>
            <h2>1. Información que recopilamos</h2>
            <p>Podemos recopilar datos personales como nombre, correo electrónico, número de teléfono e información corporativa cuando usted se comunica con nosotros o solicita nuestros servicios.</p>

            <h2>2. Uso de la información</h2>
            <p>La información recopilada se utilizará exclusivamente para:</p>
            <ul>
              <li>Proveer información técnica y cotizaciones de servicios ambientales.</li>
              <li>Gestionar la relación comercial y técnica.</li>
              <li>Enviar reportes o actualizaciones de proyectos en ejecución.</li>
            </ul>

            <h2>3. Seguridad de los datos</h2>
            <p>Implementamos medidas técnicas y organizativas para proteger sus datos contra acceso no autorizado, alteración o destrucción.</p>

            <p style={{ marginTop: '2rem' }}>
              <em>Última actualización: Marzo 2026. Para mayor información, contáctenos en ventas@cinbiosis.com</em>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
